// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gradient[data-v-2c6dddc6]{background:linear-gradient(0deg,#14177c 0,#2d3542)}.img[data-v-2c6dddc6]{width:100%;max-width:25rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
